export default "__VITE_ASSET__BXKSwhdX__"